document.addEventListener('DOMContentLoaded', function () {

  const STORAGE_KEY = 'veeroeyeSizeMeasurement';
  const rawData = localStorage.getItem(STORAGE_KEY);

  if (!rawData) return;

  let veeroData;
  try {
    veeroData = JSON.parse(rawData);
  } catch (e) {
    console.error('No Veero localStorage data');
    return;
  }

  if (!veeroData.as_worn) return;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (!cart.items || !cart.items.length) return;

      cart.items.forEach(item => {
        const handle = item.handle;

        if (!veeroData.as_worn[handle]) return;

        const asWorn = veeroData.as_worn[handle];

        const properties = {
          ...item.properties,
          _left_virtual_sh: (asWorn.left_virtual_sh * 1000).toFixed(2)+' mm',
          _right_virtual_sh: (asWorn.right_virtual_sh * 1000).toFixed(2)+' mm',
          _binocular_pd: veeroData.binocular_pd,

        //   left_vd: (asWorn.left_vd * 1000).toFixed(2),
        //   right_vd: (asWorn.right_vd * 1000).toFixed(2),
        //   left_mono_pd: (asWorn.left_mono_pd * 1000).toFixed(2),
        //   right_mono_pd: (asWorn.right_mono_pd * 1000).toFixed(2),
        //   frame_fit: asWorn.frame_fit,
        //   face_width: veeroData.face_width,
        //   eye_width: veeroData.eye_width,
        //   bridge_width: veeroData.bridge_width,
        //   temple_length: veeroData.temple_length 
        };

        updateCartItem(item.key, properties);
      });
    });

  function updateCartItem(lineKey, properties) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        properties: properties
      })
    })
    .then(res => res.json())
    .then(updatedCart => {
      console.log('Veero properties added to cart item');
      // Remove local storage
      localStorage.removeItem("veeroeyeSizeMeasurement");
    })
    .catch(err => {
      console.error('Failed to update cart item', err);
    });
  }

});
